import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import '../assets/App.scss';
import '../assets/globalStyles.css';
import * as bulmaToast from "bulma-toast";
import {saveState} from "../_helpers"

const CardMenu = (props) => {
    let navigate = useNavigate();
    const [timeOut, setTimeOut] = useState(0)
    const handleClick = (item) => {
        if (!props.available) {
            if (timeOut === 0)
                bulmaToast.toast({
                    message: "Stock barang habis",
                    type: "is-danger",
                    toastOnce: false,
                    position: "bottom-center"
                });

            setTimeOut(2000)

            setTimeout(() => {
                setTimeOut(0)
            }, 2000)

        } else {
            navigate('/detail?id=' + props.item_id + '&category=' + props.category_name)
            saveState("item-tenant", item)
            saveState("tenantCategory", props.category_name)
            saveState("item-pic", props.source)
        }
    }
    return (
        <article className="media" onClick={() => handleClick(props.item)}>

            <div className="media-content">
                <div className="content has-text-black">
                    <span
                        className={props.available ? "font-medium" : "font-medium has-text-grey-light"}>{props.foodName}</span>
                    <p className="text-bold">Rp {props.price} <br/> {props.available ? null :
                        <span className="has-text-danger">OUT OF STOCK</span>}</p>
                </div>
            </div>

            <div className="media-left">
                <figure className="image is-96x96">
                    <img src={props.source} alt=""/>
                </figure>
            </div>

        </article>
    )
}

export default CardMenu;
